import { statementStatisticsRouter } from "@/routers/warehouseManagement/statementStatistics.ts";
import { contractManagementRouter } from "@/routers/warehouseManagement/contractManagement.ts";
import { warehouseStorageManageRouter } from "@/routers/warehouseManagement/storage.ts";
import { ROLE_TYPE } from "@supplier/meta";
import { UserStore } from "@/stores/modules/user.ts";
import { storeProjectRouter } from "@/routers/warehouseManagement/storeProject.ts";
const warehouseManagementRouters = [
    {
        path: "/warehouseManagementCompany",
        name: "WarehouseManagementCompany",
        meta: {
            title: "仓储管理",
            icon: "icon-a-cangchu1",
            hidden: ({ userStore }: { userStore: UserStore }) => {
                // 拥有仓储管理企业身份显示。
                return (
                    userStore.isSAAS && !userStore.userInfo.supplier?.roles?.includes(ROLE_TYPE.WAREHOUSE_MANAGE_SUPERVISION.code)
                );
            }
        },
        children: [
            ...storeProjectRouter,
            ...contractManagementRouter,
            ...warehouseStorageManageRouter,
            ...statementStatisticsRouter
        ]
    }
];
export default warehouseManagementRouters;
